"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAttributeValueItem = exports.StyledAttributeValueItemContainer = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const generic_1 = require("../../../../generic");
exports.StyledAttributeValueItemContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};

  .nested-values-section {
    padding-left: ${({ theme }) => theme.spacing(2)};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(1.5)};
  }
`;
exports.StyledAttributeValueItem = (0, styled_components_1.default)(generic_1.ListRowItem) `
  display: flex;
  align-items: center;
  min-height: 40px;
  gap: ${({ theme }) => theme.spacing(1)};

  &:not(.attribute-value--disabled) {
    cursor: pointer;
    background-color: transparent;
  }

  &.attribute-value--selected {
    background-color: ${ui_components_1.baseColors.primaryGreen001};
  }

  &.attribute-value--has-error {
    color: ${ui_components_1.baseColors.darkRed};
  }
`;
